import {
  INITIAL_CHECKOUT_ADDONS,
  INITIAL_CHECKOUT_DATA,
  UPDATE_CHECKOUT_ADDONS_DATA,
  UPDATE_CHECKOUT_DATA,
  UPDATE_CHECKOUT_NESTED_DATA,
} from './types';
import { FINANCE_PRIVATE_LEASING } from '../../../components/ProductDetail/Checkout/helpers/finance';

export const getAddonsFieldName = (financeType) => {
  switch (financeType) {
    case FINANCE_PRIVATE_LEASING:
      return 'privateLeasingAddons';

    default:
      return 'addons';
  }
};

export const checkoutActions = (type, value, key, nestedKey) => (dispatch, getState) => {
  const reduxFieldState = { ...getState() };
  const checkoutState = reduxFieldState.checkout;

  switch (type) {
    case INITIAL_CHECKOUT_DATA:
      dispatch({
        type: INITIAL_CHECKOUT_DATA,
        payload: {
          checkout: { [key]: value },
        },
      });
      break;

    case INITIAL_CHECKOUT_ADDONS:
      const newAddons = (value || []).map((item) => ({ ...item, chosen: false }));

      dispatch({
        type: INITIAL_CHECKOUT_ADDONS,
        payload: {
          checkout: { [key]: newAddons },
        },
      });
      break;

    case UPDATE_CHECKOUT_DATA:
      dispatch({
        type: UPDATE_CHECKOUT_DATA,
        payload: {
          checkout: { [key]: value },
        },
      });
      break;

    case UPDATE_CHECKOUT_NESTED_DATA:
      const newCheckoutObj = { ...checkoutState };
      newCheckoutObj[key][nestedKey] = value;

      dispatch({
        type: UPDATE_CHECKOUT_NESTED_DATA,
        payload: {
          checkout: { ...newCheckoutObj },
        },
      });
      break;

    case UPDATE_CHECKOUT_ADDONS_DATA:
      const newAddonsCheckoutObj = { ...checkoutState };
      const addonsField = getAddonsFieldName(newAddonsCheckoutObj.chosenCheckoutType);

      newAddonsCheckoutObj[addonsField] = (newAddonsCheckoutObj[addonsField] || []).map(
        (item, index) => {
          if (item.type === nestedKey) {
            item.chosen = value;
          }
          return item;
        }
      );

      dispatch({
        type: UPDATE_CHECKOUT_ADDONS_DATA,
        payload: {
          checkout: { ...newAddonsCheckoutObj },
        },
      });
      break;

    default:
      break;
  }
};
